import type { Role } from '../schemas';

export const ROLE_LABEL: Record<Role, string> = {
	ADMIN: 'Administrator',
	AUDITOR: 'Auditor',
	DATA_ENTRY: 'Data entry',
};

export const ROLE_BLURB: Record<Role, string> = {
	ADMIN: 'Administers people and clients, and can stand in either place.',
	AUDITOR: 'Reads prepared data and runs analyses. Never uploads or maps.',
	DATA_ENTRY: 'Prepares the client’s data. Never opens an audit.',
};

export const ASSIGNABLE_ROLES: readonly Role[] = [
	'ADMIN',
	'AUDITOR',
	'DATA_ENTRY',
];

/* Least authority first, so the list reads as a ladder and the safest choice
   is the one the cursor lands on. */
export const ROLE_ORDER: Role[] = ['DATA_ENTRY', 'AUDITOR', 'ADMIN'];

export const ROLE_OPTIONS = ROLE_ORDER.map((role) => ({
	value: role,
	label: ROLE_LABEL[role],
}));

/** The two live states that are really "nothing has started yet". */
const PREPARING = new Set(['DRAFT', 'SETUP']);

/** The two live states where a report exists, current or superseded. */
const REPORTED = new Set(['CLOSED', 'RESTATED']);

/** An audit's status, as the auditor's half of the product groups it. */
export function auditorStatus(status: string): string {
	if (PREPARING.has(status)) return 'PREPARING_DATA';
	if (REPORTED.has(status)) return 'REPORTED';
	return status;
}
